export { default } from './ViewToggle';
